export const CAPABILITY_PLAN_NAME_MAP = {
  plan_pro_monthly: "Pro Monthly",
  plan_pro_quarterly: "Pro Quarterly",
  plan_pro_half_yearly: "Pro Half-Yearly",
  plan_pro_yearly: "Pro Yearly",
  plan_pro_monthly_dedicated: "Pro Monthly (Dedicated)",
  plan_enterprise: "Enterprise",
};

export const mapCapabilityPlanIdToName = (planId) => {
  if (!planId) return null;
  return CAPABILITY_PLAN_NAME_MAP[planId] || planId;
};